// Data Migration — data_migration.* (Settings → Data Migration)
// Backend keys registered by migration 2026_09_06_000002_add_data_migration_permissions.
// The ids are the central-assigned approval numbers (approved 2026-09-06). An id
// that does not equal its backend `permissions.id` fails SILENTLY —
// HAS_PERMISSION returns false, so the settings tab and the import button never
// appear, with no error anywhere.

/** data_migration.index — the screen: template, upload, report */
export const DATA_MIGRATION_INDEX = 1572;
/** data_migration.show — no such key by convention; the detail view is guarded by index. */
export const DATA_MIGRATION_SHOW = DATA_MIGRATION_INDEX;
/** data_migration.import — writing the checked portfolio into live data */
export const DATA_MIGRATION_IMPORT = 1573;
